var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-row"},[_c('div',{staticClass:"font-weight-bold text-lg text-gray-800"},[_c('span',[_vm._v("\n\t\t\t"+_vm._s(_vm.data.product_data.name)+"\n\t\t")])])])}
var staticRenderFns = []

export { render, staticRenderFns }